<template>
  <div id="world-container">
    <div id="world" ref="worldRef">
      <Map :data="data" />
    </div>
  </div>
</template>

<script>
import {provide, ref} from '@vue/composition-api'

import useZoom from '@/composition/useZoom'
import * as providers from '@world/providers'

export default {
  props: {
    data: {type: Object, required: true},
  },
  setup (props, context) {
    const worldRef = ref()
    provide(providers.OPTIONS, {
      assetBaseUrl: props.data.assetBaseUrl,
    })

    useZoom(worldRef)

    return {
      worldRef,
    }
  },
}
</script>

<style scoped lang="scss">
#world-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #5B4E98 0%, #7C7FAC 25%, #94A3BB 75%, #B9E5D6 100%);
  overflow: hidden;
  overflow-y: auto;
}

@keyframes pop-in {
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

#world {
  position: relative;
  width: 1024px;
  height: 1366px;
  // animation: pop-in 700ms cubic-bezier(0.22, 1, 0.36, 1); // easeOutQuint
  animation: pop-in 1000ms cubic-bezier(0.25, 1, 0.5, 1); // easeOutQuart

  @include media.query($from: 1024) {
    margin-top: -60px;
  }
}
</style>
